import React from 'react'
import { connect } from 'react-redux'
import { selectors } from '../../../duck'
import { RootState } from 'duck'
import { ReduxProps } from 'utils/Types'
import FreeformCuration from './FreeformCuration'
import NonFreeFormCuration from './NonFreeFormCuration'

const mapStateToProps = (state: RootState) => ({
  isProjectFreeform: selectors.isProjectFreeform(state)
})

type InfoCurateCollectionProps = ReduxProps<typeof mapStateToProps>

const InfoCurateCollection: React.FC<InfoCurateCollectionProps> = props => {
  const { isProjectFreeform } = props

  return isProjectFreeform ? <FreeformCuration /> : <NonFreeFormCuration />
}

export default connect(mapStateToProps)(InfoCurateCollection)
